export const EMPTY_DISPLAY_VALUE = "—";
